module.exports = __webpack_public_path__ + "img/lev_yes.a290fec0.png";